module.exports = __webpack_public_path__ + "img/voyager.f8e4356d.png";